export const CLEAR_DATA = 'CLEAR_DATA';
export const WORK_AT_RECYCLE_BIN = 'WORK_AT_RECYCLE_BIN';
export const ON_CHANGE_DATA = 'ON_CHANGE_DATA';
export const ACTIVATE_TAB = 'ACTIVATE_TAB';
export const VIEW_CHILD_DOCUMENT = 'VIEW_CHILD_DOCUMENT';
export const SHOW_INVOICE_ITEM = 'SHOW_INVOICE_ITEM';
export const CHANGE_MODE = 'CHANGE_MODE';
export const FOCUS_ON_FIELD_IN_IMAGE = 'FOCUS_ON_FIELD_IN_IMAGE'
export const MAP_FORM_AND_IMAGE = 'MAP_FORM_AND_IMAGE'
export const SCROLL_FORM_OR_IMAGE = 'SCROLL_FORM_OR_IMAGE'
export const CLEAR_FORM_AND_IMAGE_MAPPER = 'CLEAR_FORM_AND_IMAGE_MAPPER'

export const GET_DETAIL_DOCUMENT_HISTORY = 'GET_DETAIL_DOCUMENT_HISTORY';
export const GET_DETAIL_DOCUMENT_HISTORY_SUCCESS = 'GET_DETAIL_DOCUMENT_HISTORY_SUCCESS';
export const GET_DETAIL_DOCUMENT_HISTORY_FAILED = 'GET_DETAIL_DOCUMENT_HISTORY_FAILED';

export const EDIT_DOCUMENT = 'EDIT_DOCUMENT';
export const EDIT_DOCUMENT_SUCCESS = 'EDIT_DOCUMENT_SUCCESS';
export const EDIT_DOCUMENT_FAILED = 'EDIT_DOCUMENT_FAILED';

export const REDIRECT_BACK = 'REDIRECT_BACK';

export const GET_DOCUMENT_SERVICE_API_V2_DOCUMENT_SUCCESS = 'GET_DOCUMENT_SERVICE_API_V2_DOCUMENT_SUCCESS'
export const UPDATE_DOCUMENT_SERVICE_API_V2_DOCUMENT_SUCCESS = 'UPDATE_DOCUMENT_SERVICE_API_V2_DOCUMENT_SUCCESS'


// DEPEND DOCUMENT //
export const UPLOAD_DEPEND_DOCUMENT = 'UPLOAD_DEPEND_DOCUMENT';
export const UPLOAD_DEPEND_DOCUMENT_SUCCESS = 'UPLOAD_DEPEND_DOCUMENT_SUCCESS';
export const UPLOAD_DEPEND_DOCUMENT_FAILED = 'UPLOAD_DEPEND_DOCUMENT_FAILED';

export const DELETE_DEPEND_DOCUMENT = 'DELETE_DEPEND_DOCUMENT';
export const DELETE_DEPEND_DOCUMENT_SUCCESS = 'DELETE_DEPEND_DOCUMENT_SUCCESS';
export const DELETE_DEPEND_DOCUMENT_FAILED = 'DELETE_DEPEND_DOCUMENT_FAILED';

// SHARE DOCUMENT //
export const SHARE_DOCUMENT = 'SHARE_DOCUMENT';
export const SHARE_DOCUMENT_SUCCESS = 'SHARE_DOCUMENT_SUCCESS';
export const SHARE_DOCUMENT_FAILED = 'SHARE_DOCUMENT_FAILED';

// SHARE DOCUMENT //
export const LIST_FOLDER_BY_GROUP = 'LIST_FOLDER_BY_GROUP';
export const LIST_FOLDER_BY_GROUP_SUCCESS = 'LIST_FOLDER_BY_GROUP_SUCCESS';
export const LIST_FOLDER_BY_GROUP_FAILED = 'LIST_FOLDER_BY_GROUP_FAILED';

// DOWNLOAD DOCUMENT //
export const DOWNLOAD_DOCUMENT = 'DOWNLOAD_DOCUMENT';
export const DOWNLOAD_DOCUMENT_SUCCESS = 'DOWNLOAD_DOCUMENT_SUCCESS';
export const DOWNLOAD_DOCUMENT_FAILED = 'DOWNLOAD_DOCUMENT_FAILED';

export const DOWNLOAD_DOCUMENT_LINK = 'DOWNLOAD_DOCUMENT_LINK';
export const DOWNLOAD_DOCUMENT_LINK_SUCCESS = 'DOWNLOAD_DOCUMENT_LINK_SUCCESS';
export const DOWNLOAD_DOCUMENT_LINK_FAILED = 'DOWNLOAD_DOCUMENT_LINK_FAILED';

export const DOWNLOAD_DEPENDANT_DOCUMENT = 'DOWNLOAD_DEPENDANT_DOCUMENT';
export const DOWNLOAD_DEPENDANT_DOCUMENT_SUCCESS = 'DOWNLOAD_DEPENDANT_DOCUMENT_SUCCESS';
export const DOWNLOAD_DEPENDANT_DOCUMENT_FAILED = 'DOWNLOAD_DEPENDANT_DOCUMENT_FAILED';

export const GET_DOCUMENT_ID = 'GET_DOCUMENT_ID';
export const GET_DOCUMENT_ID_SUCCESS = 'GET_DOCUMENT_ID_SUCCESS';
export const GET_DOCUMENT_ID_FAILED = 'GET_DOCUMENT_ID_FAILED';

// MASS UPDATE
export const MASS_UPDATE_DOCUMENT = 'MASS_UPDATE_DOCUMENT';
export const MASS_UPDATE_DOCUMENT_SUCCESS = 'MASS_UPDATE_DOCUMENT_SUCCESS';
export const MASS_UPDATE_DOCUMENT_FAILED = 'MASS_UPDATE_DOCUMENT_FAILED';

// RESTORE DOCUMENTS
export const EMPTY_RECYCLE_BIN = 'EMPTY_RECYCLE_BIN';
export const EMPTY_RECYCLE_BIN_SUCCESS = 'EMPTY_RECYCLE_BIN_SUCCESS';
export const EMPTY_RECYCLE_BIN_FAILED = 'EMPTY_RECYCLE_BIN_FAILED';

// Unilever Customize Phase 1+ //
export const GET_REASON_ID = 'GET_REASON_ID';
export const GET_REASON_ID_SUCCESS = 'GET_REASON_ID_SUCCESS';
export const GET_REASON_ID_FAILED = 'GET_REASON_ID_FAILED';

export const GET_PARKING_ID = 'GET_PARKING_ID';
export const GET_PARKING_ID_SUCCESS = 'GET_PARKING_ID_SUCCESS';
export const GET_PARKING_ID_FAILED = 'GET_PARKING_ID_FAILED';

// Unilever Customize //
export const VALIDATE_CONTRACT_NUMBER = 'VALIDATE_CONTRACT_NUMBER';
export const VALIDATE_CONTRACT_NUMBER_SUCCESS = 'VALIDATE_CONTRACT_NUMBER_SUCCESS';
export const VALIDATE_CONTRACT_NUMBER_FAILED = 'VALIDATE_CONTRACT_NUMBER_FAILED';

export const VALIDATE_SHIPPING_DOCUMENT = 'VALIDATE_SHIPPING_DOCUMENT';
export const VALIDATE_SHIPPING_DOCUMENT_SUCCESS = 'VALIDATE_SHIPPING_DOCUMENT_SUCCESS';
export const VALIDATE_SHIPPING_DOCUMENT_FAILED = 'VALIDATE_SHIPPING_DOCUMENT_FAILED';